<template>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.56836 14.8799V16.5584C4.56836 17.663 5.46379 18.5584 6.56836 18.5584H12.0049" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M12.2168 5.44105L12.2168 12.3975" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M14.7024 10.7109L12.2154 13.2891L9.72852 10.7109" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M15.0039 16L20.0039 21" stroke="#F06269" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M20.0039 16L15.0039 21" stroke="#F06269" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>
